import { useEffect, useState } from 'react';
import Icon, { Icons } from '../Icon/Icon';
import Input from '../Input';
import './PaymentPurpose.scss';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { appSlice } from '../../store/slices';
import { t } from '../../lang';

const requiredErrorMessage =
	'To proceed, you must provide a payment purpose or attach a supporting file.';

const PaymentPurpose = ({ comment, setComment, isRequired, externalRef }) => {
	const intl = useIntl();
	const dispatch = useDispatch();
	const [requiredError, setRequiredError] = useState();

	const uploadFiles = useSelector(store => store.send.approvalFiles);

	const handleOpenModal = () => {
		dispatch(
			appSlice.actions.addModal({
				isHeaderWithColorBgAndIcon: true,
				title: t('Upload files'),
				subtitle: t('Maximum file size: 10 MB'),
				headerBackgroundColor: '#0455A3',
				headerIcon: 'DOCUMENT_FILL',
				tag: 'TransactionFilesModal',
				isOpen: true,
				height: '70%',
				// outsideParams: { methods: sortedMethods, selectMethod },
			})
		);
	};

	const handleOnBlur = e => {
		if (!isRequired) return;
		const value = e.target.value;
		if (!value && !uploadFiles.length) {
			setRequiredError(requiredErrorMessage);
		} else {
			setRequiredError(null);
		}
	};

	const handleOnFocus = () => {
		if (!isRequired) return;
		if (!comment && !uploadFiles.length) {
			setRequiredError(requiredErrorMessage);
		}
	};

	useEffect(() => {
		if (isRequired && !comment && uploadFiles.length > 0) {
			setRequiredError(null);
		}
	}, [uploadFiles.length]);

	return (
		<div className='payment-purpose'>
			<Input
				value={comment}
				onChange={setComment}
				placeholder={intl.formatMessage({ id: 'Comment' })}
				error={!!requiredError}
				subtext={
					requiredError ? intl.formatMessage({ id: requiredError }) : null
				}
				className='payment-purpose-input'
				onBlur={handleOnBlur}
				onFocus={handleOnFocus}
				maxLength={256}
				externalRef={externalRef}
			/>
			<div className='payment-purpose-icon'>
				<Icon
					className='PhoneInput__cross-icon'
					onClick={handleOpenModal}
					type={Icons.PAPER_CLIP}
					width={24}
					height={24}
				/>
				{uploadFiles.length > 0 && (
					<div className='payment-purpose-counter'>{uploadFiles.length}</div>
				)}
			</div>
		</div>
	);
};

export default PaymentPurpose;
